<template>
    <div>
        <ContentLink :href="post.url">
            <ContentImage :src="post.preview"/>
            <Title>{{post.title}}</Title>
        </ContentLink>
        <UserInfo :memberName="author.name" :memberUrl="author.profile_url">
            <span slot="post-date">{{postDate}}</span>
        </UserInfo>
    </div>
</template>

<script>
    import Title from '../shared/card/Title'
    import ContentImage from '../shared/card/ContentImage'
    import ContentLink from '../shared/card/ContentLink'
    import UserInfo from '../shared/card/UserInfo'
    import moment from 'moment'

    export default {
        name: 'BlogContent',
        props: {
            post: Object,
            author: Object
        },
        components: {
            Title,
            ContentImage,
            UserInfo,
            ContentLink
        },
        computed: {
            postDate: function () {
                if (this.post.date) {
                    return moment(this.post.date).format('MMMM D')
                }
                return undefined;
            }
        }
    }
</script>
